<template>
  <div>
    <table class="table" cellspacing="0" cellpadding="0">
      <thead>
        <tr>
          <th>Current Accommodation</th>
          <th>Accommodation Updated To</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <template v-for="(bookings, accommodation) in groupedBookings">
          <tr :key="accommodation + '-accommodation'">
            <td>
              {{ bookings[0].room.accommodation.details.accommodation_name }} 
              <small>
                {{ bookings[0].room.accommodation_room.name }} {{bookings[0].room.accommodation_room.board_basis}}
                <template v-if="bookings[0].selected_multiple_room">({{ bookings[0].selected_multiple_room }})</template>
              </small>
            </td>
            <td v-if="bookings[0].updatedAccommodation">{{ bookings[0].updatedAccommodation.accommodation }} <small>{{ bookings[0].updatedAccommodation.room_type }}</small></td>
            <td v-else>-</td>
            <td class="table-action" @click="updateAccommodationGroup(bookings)"><button>Update</button></td>
          </tr>
        </template>
      </tbody>
    </table>
    <div class="m-3">
      <b>Note: Bulk update of accommodation will not consider canceled bookings</b>
    </div>
    <div class="text-center m-4">
      <button type="button" class="button" @click="tourGroupUpdateAccommodation"><span>Submit</span></button>
    </div>
    <div class="modal" v-if="showSelectNewAccommodationModal" style="box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;">
     <h1>Select Accommodation</h1>
      <div class="box">
        <AccommodationSelect :type="'tour-group'" @accommodation-select="selectedAccommodation"/>
      </div>
      <button type="button" class="icon icon--unlink" v-on:click="showSelectNewAccommodationModal = false">Close</button>
    </div>
  </div>
</template>

<script>
import AccommodationSelect from '@/components/AccommodationSelect.vue';
export default {
  props : {
    groupedBookings: Object,
  },
  components: {
    AccommodationSelect
  },
  data() {
    return  {
      accommodations: [],
      expandedAccommodation: null,
      showSelectNewAccommodationModal: false,
      booking: [],
      updatedAccommodationGroup: []
    }
  },
  mounted() {
  },
  methods: {
    updateAccommodationGroup(bookings) {
      this.booking = bookings;
      this.showSelectNewAccommodationModal = true;
    },
    selectedAccommodation(room, accommodation, room_selected_value=null) {
      this.showSelectNewAccommodationModal = false;
      this.booking[0].updatedAccommodation = {
        accommodation : accommodation.accommodation_name,
        room_type : room.name + " " + room.board_basis + (room_selected_value ? ` (${room_selected_value})` : ""),
        room_id: room.id,
        accommodation_id: room.accommodation_id,
        room_selected_value: room_selected_value
      }
    },
   tourGroupUpdateAccommodation() {
    this.$dialog
      .confirm('Are you sure you want to update the accommodation?')
      .then(() => {
        const updatedAccommodationGroup = [];

        const groupedBookingsArray = Object.values(this.groupedBookings).filter(Array.isArray);

        groupedBookingsArray.forEach((groupedBooking) => {
          if (groupedBooking[0].updatedAccommodation) {
            updatedAccommodationGroup.push({
              old_accommodation_detail: {
                room_id: groupedBooking[0].room.accommodation_room.id,
                accommodation_id: groupedBooking[0].room.accommodation.accommodation_id,
              },
              new_accommodation_detail: {
                room_id: groupedBooking[0].updatedAccommodation.room_id,
                accommodation_id: groupedBooking[0].updatedAccommodation.accommodation_id,
                selected_multiple_room: groupedBooking[0].updatedAccommodation.room_selected_value
              },
              booking_ids: groupedBooking.map(obj => obj.id)
            });
          }
        });

        const accommodationRequest = {
          updated_accommodation: updatedAccommodationGroup,
        };

        // console.log(accommodationRequest);
        // return        

        this.$store.dispatch('setLoadStatus');

        fetch(this.$api + 'tours/groups/' + this.$route.params.id + '/booking/bulk-update-accommodation', {
          method: 'POST',
          body: JSON.stringify(accommodationRequest),
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': localStorage.getItem('token')
          }
        })
        .then(res => res.json())
        .then(response => {
          if (response.success) {
            this.$notify({
              type: 'success',
              title: response.message
            });
            this.$parent.bulkAccommodationUpdateModal = false;
          } else if (response.errors) {
            this.$notify({
              type: 'error',
              title: response.message
            });
          } else {
            this.$notify({
              type: 'error',
              title: response.message
            });
          }
          this.$store.dispatch('setLoadStatus');
        })
        .catch(error => {
          this.$store.dispatch('setLoadStatus');
          console.error('Error:', error);
          this.$notify({
            type: 'error',
            title: 'An error occurred'
          });
        });
      })
      .catch(() => {
        console.log('Clicked on cancel');
      });
    }
  }
};
</script>
